import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'error-message.unknown-file-type': {
    id: 'error-message.unknown-file-type',
    defaultMessage: 'Unknown file type {fileType}.',
    description:
      'The error message shown when a user tries to import a file with an unknown file type.',
  },
  'import-entries-dialog.cancel-button': {
    id: 'import-entries-dialog.cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The text for the cancel button that appears when importing from CSV. Clicking on it exists the import dialog.',
  },
  'import-entries-dialog.change-file': {
    id: 'import-entries-dialog.change-file',
    defaultMessage: 'Change file',
    description:
      'The text for the change file link button that appears after importing a CSV. Clicking on it goes back to the import dialog.',
  },
  'import-entries-dialog.import-button': {
    id: 'import-entries-dialog.import-button',
    defaultMessage: 'Import',
    description:
      'The text for the confirmation button that appears when importing CSV into databases.',
  },
  'import-entries-dialog.upload': {
    id: 'import-entries-dialog.upload',
    defaultMessage: 'Upload',
    description: 'The text for the Upload button where users can upload a file.',
  },
  'import-entries-dialog.upload-description-text': {
    id: 'import-entries-dialog.upload-description-text',
    defaultMessage: 'Or drag and drop your CSV file here',
    description:
      'The text description for the import entries dialog upload step that asks the user to either use the upload button or drag and drop a file.',
  },
  'import-entries-dialog.import-failed': {
    id: 'import-entries-dialog.import-failed',
    defaultMessage: 'Import failed.',
    description: 'The aria label for an import failed error.',
  },
  'import-entries-dialog.configure-data': {
    id: 'import-entries-dialog.configure-data',
    defaultMessage:
      'Configure data from this file to your database and review before importing.',
    description: 'Instructions on how to import the entries after uploading the file',
  },
  'import-entries-dialog.import-file-info': {
    id: 'import-entries-dialog.import-file-info',
    defaultMessage:
      '{numberOfEntries, plural, =0 {Importing {numberOfEntries} entry from <strong>{fileName}</strong>} one {Importing {numberOfEntries} entry from <strong>{fileName}</strong>} other {Importing {numberOfEntries} entries from <strong>{fileName}</strong>}}',
    description:
      'Information about the file being imported as well as the number of entries included in each file.',
  },
  'import-entries-dialog.heading': {
    id: 'import-entries-dialog.heading',
    defaultMessage: 'Import entries',
    description: 'The heading text for the import entries dialog.',
  },
  'import-field.create-new-field-text': {
    id: 'import-field.create-new-field-text',
    defaultMessage: 'Create new text field {fieldName}',
    description:
      'The error message for importing fields when multiple columns are selected.',
  },
  'import-field.exclude-from-import': {
    id: 'import-field.exclude-from-import',
    defaultMessage: 'Exclude from import',
    description: 'The option for skipping a field from import.',
  },
  'import-select-or-create-text.placeholder': {
    id: 'import-select-or-create-text.placeholder',
    defaultMessage: 'Select or create…',
    description: 'The placeholder text for a select or create dropdown.',
  },
  'import-field.error-multiple-columns-text': {
    id: 'import-field.error-multiple-columns-text',
    defaultMessage: 'Multiple columns cannot be mapped to the same field.',
    description:
      'The error message for importing fields when multiple columns are selected.',
  },
  'import-field.error-select-a-field-text': {
    id: 'import-field.error-select-a-field-text',
    defaultMessage: 'Please select a field.',
    description: 'The error message for importing fields when a field is not selected.',
  },
  'import-field-settings.field-name-inline-edit-default-text': {
    id: 'import-field-settings.field-name-inline-edit-default-text',
    defaultMessage: '{defaultFieldName} field',
    description: 'The default field name for a field name.',
  },
  'import-field-settings.type-text': {
    id: 'import-field-settings.type-text',
    defaultMessage: 'Text',
    description:
      'The text associated with the dropdown menu button for the Text database field type.',
  },
  'snackbar-warning.pasting-over-existing-content': {
    id: 'snackbar-warning.pasting-over-existing-content',
    defaultMessage: 'Existing values replaced.',
    description:
      'This message is shown in a snackbar when the user pastes values over existing values.',
  },
  'snackbar-warning.pasting-over-existing-content-undo': {
    id: 'snackbar-warning.pasting-over-existing-content-undo',
    defaultMessage: 'Undo',
    description:
      'When a user pastes content over existing content, a snackbar appears warning them of the overwrite. This message is the text of the link that will allow them to undo the operation.',
  },
  'snackbar-warning.pasting-content-that-doesnt-match': {
    id: 'snackbar-warning.pasting-content-that-doesnt-match',
    defaultMessage: 'Pasted data does not match database field types.',
    description:
      'This message is shown in a snackbar when the user pastes values into another field where they cannot be converted properly.',
  },
  'import-file-error.invalid-file': {
    id: 'import-file-error.invalid-file',
    defaultMessage:
      'The selected file is not supported for upload. Make sure you are importing a valid .csv',
    description:
      'The error message shown when a user tries to import a file other than a CSV or a CSV that is malformed or empty.',
  },
  'import-file-error.too-many-files': {
    id: 'import-file-error.too-many-files',
    defaultMessage: 'You can only upload one file at a time. ',
    description:
      'The error message shown when a user tries to drag and drop multiple files for import',
  },
  'snackbar-error-message.unsupported-mime-type': {
    id: 'snackbar-error-message.unsupported-mime-type',
    defaultMessage:
      'Only these types are supported: text/html, text/csv, text/tab-separated-values, text/plain. The imported file has the type {fileType}.',
    description:
      'The error message is shown when a user tries to import a file with a type that is not supported.',
  },
  'snackbar-error-message.cannot-read-pasted-file': {
    id: 'snackbar-error-message.cannot-read-pasted-file',
    defaultMessage: 'Pasted file cannot be read.',
    description:
      'The error message shown when a user tries to paste a file, but the contents cannot be read.',
  },
  'snackbar-error-message.unexpected-data-type': {
    id: 'snackbar-error-message.unexpected-data-type',
    defaultMessage: 'Unexpected data type.',
    description:
      'The error message shown when a user tries to import a file with a data type that is not supported.',
  },
  'snackbar-error-message.table-could-not-be-found-in-html': {
    id: 'snackbar-error-message.table-could-not-be-found-in-html',
    defaultMessage: 'No table could be found in the imported HTML.',
    description:
      "The error message shown when the user tries to import HTML that doesn't contain a table.",
  },
  'snackbar-error-message.unexpected-import-type': {
    id: 'snackbar-error-message.unexpected-import-type',
    defaultMessage: 'Unexpected import file type {fileType}.',
    description:
      'The error message is shown when the file type could not be determined from the user’s imported file.',
  },
});
